<template lang="html">
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3863.700764026332!2d100.27230211483835!3d14.44440078990206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2152cf3d0a047%3A0x654711012df04431!2sNaics+Furnishing+Co.%2C+Ltd.!5e0!3m2!1sen!2sth!4v1539872340532"
    width="1400"
    height="400"
    frameborder="0"
    style="border:0"
    allowfullscreen>
  </iframe>
  <!-- <GmapMap
    :center="{lat:13.7092612, lng:100.4068556}"
    :zoom="13"
    style="width: auto; height: 400px"
  >
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position"
  />
  </GmapMap> -->
</template>

<script>
export default {
  data () {
    return {
      markers: [
        {
          position: {lat: 13.7, lng: 100.4068556}
        },
        {
          position: {lat: 11.0, lng: 12.0}
        }
      ]
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/map.vue